import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TextField,
  TableContainer,
  Box,
  debounce,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  capitalize,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { useRef, useState } from "react";
import service from "../../Helpers/gifservices";
import { useLoading } from "../../../../providers/loadingProvider";
import { useNotify } from "../../../../providers/NotificationProvider";
import AddRefereeForm from "./AddRefereeForm";
import { recommendedBy } from "../../Constants";
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(2),
    overflowX: "auto",
    maxHeight: 700,
    height: 570,
  },
  table: {
    maxHeight: 450,
    width: "100%",
  },
  tableCell: {
    fontWeight: 600,
    color: "#4B4B4B",
  },
  secoundTypography: {
    color: "#4B4B4B",
    fontWeight: 400,
    display: "inline",
  },
  addButton: {
    color: theme.palette.gif.yellow.dark,
    backgroundColor: theme.palette.gif.yellow.color,
    "&:hover": {
      backgroundColor: theme.palette.gif.yellow.hover,
    },
    padding: 2,
  },
  addReviewerButton: {
    color: theme.palette.gif.yellow.dark,
    backgroundColor: theme.palette.gif.yellow.color,
    "&:hover": {
      backgroundColor: theme.palette.gif.yellow.hover,
    },
    width: 120,
  },
  iconButton: {
    padding: 2,
  },
  saveButton: {
    "&:hover": {
      backgroundColor: theme.palette.gif.blue.hover,
    },
    color: theme.palette.gif.blue.color,
    backgroundColor: theme.palette.gif.blue.background,
    width: 120,
    marginTop: 10,
    marginBottom: 5,
    marginLeft: 6,
    marginRight: 6,
    borderRadius: 8,
  },
  cancelButton: {
    "&:hover": {
      backgroundColor: theme.palette.gif.red.hover,
    },
    color: theme.palette.gif.red.color,
    backgroundColor: theme.palette.gif.red.background,
    float: "right",
    width: 120,
    marginTop: 10,
    marginBottom: 5,
    borderRadius: 8,
    position: "absolute",
    right: 15,
    bottom: 5,
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  paper: {
    position: "absolute",
    width: "90%",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #000",
    borderRadius: 10,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    top: `30%`,
    left: `18%`,
    transform: `translate(-15%, -25%)`,
  },
}));

const ReviewerRow = (props) => {
  const { reviewer, addReviewer } = props;
  const [buttonClick, setButtonClick] = useState(false);
  const classes = useStyles();
  return (
    <TableRow>
      <TableCell>{reviewer.fullName}</TableCell>
      <TableCell>{reviewer.primaryEmail}</TableCell>
      <TableCell>{reviewer.websiteurl}</TableCell>
      <TableCell>{reviewer.keywords}</TableCell>
      <TableCell>
        <Button
          disableElevation
          variant="contained"
          size="small"
          className={classes.addReviewerButton}
          disabled={buttonClick}
          onClick={() => {
            addReviewer(reviewer.contactId, reviewer.primaryEmail);
            setButtonClick(true);
          }}
        >
          Add Reviewer
        </Button>
      </TableCell>
    </TableRow>
  );
};

export default function SuggestedReviewer(props) {
  const classes = useStyles();
  const loading = useLoading();
  const notify = useNotify();
  const addRefereeForm = useRef(null);
  const { proposalId, openCloseSuggestedReviewers } = props;
  const tableHeaders = [
    { label: "Name", size: "30%" },
    { label: "Email", size: "20%" },
    { label: "Website", size: "20%" },
    { label: "Keywords", size: "20%" },
    { label: "", size: "20%" },
  ];

  const [openNewReferee, setOpenNewReferee] = useState(false);
  const [reviewers, setReviewers] = useState([]);

  const addReviewer = async (contactId, contactMail) => {
    const loadingId = loading.addLoading("Adding Reviewer");
    service.registerReferee({ email: contactMail });
    const createResult = await service.CreateProposalReferee({
      proposalId,
      contactId,
    });
    loading.removeLoading(loadingId);
    if (createResult.Error)
      notify.show(createResult.Error, { severity: "error" });
    else notify.show("Reviewer has been added");
  };

  const searchContacts = debounce(async (e) => {
    const searchWord = e.target.value;
    if (searchWord === "") return;
    const loadingId = loading.addLoading("Searching Reviewers");
    var reviewers = await service.GetContats(searchWord);
    reviewers.forEach((review) => {
      if (review.keywords?.length > 40) {
        review.keywords = review.keywords.slice(0, 40).concat("...");
      }
    });
    setReviewers(reviewers);
    notify.show(`Found ${reviewers.length} reviewers`);
    loading.removeLoading(loadingId);
  }, 1000);

  const buildProposalContact = (proposalReferee) => ({
    titleCode: proposalReferee.titleCode,
    title: proposalReferee.title,
    firstName: capitalize(proposalReferee.firstName),
    lastName: capitalize(proposalReferee.lastName),
    institution: proposalReferee.institutionId,
    institutionName: proposalReferee.institutionName,
    websiteurl: proposalReferee.websiteurl,
    primaryEmail: proposalReferee.primaryEmail,
    country: proposalReferee.institutionCountryName,
    countryCode: proposalReferee.institutionCountryId,
  });
  const addNewReferee = async () => {
    const reviewer = await addRefereeForm.current.submit();
    if (reviewer === null) return;
    const loadingId = loading.addLoading("Creating Reviewer");
    const proposalRefereeContact = buildProposalContact(reviewer);
    await service.registerReferee({
      email: proposalRefereeContact.primaryEmail,
    });
    await service.createProposalRefreeByContact({
      proposalId: proposalId,
      contact: proposalRefereeContact,
      recommendedBy: recommendedBy.Advisor,
    });
    notify.show("Reviewer Has Been Created");
    setOpenNewReferee(false);
    loading.removeLoading(loadingId);
  };
  return (
    <Paper className={classes.paper}>
      <Paper elevation={0} className={classes.root}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "row",
            alignItems: "center",
            gap: 10,
          }}
        >
          <Typography className={classes.secoundTypography}>
            Suggested Reviewers
          </Typography>
          <TextField
            sx={{
              flexGrow: 1,
            }}
            label="Search Reviewer"
            size="small"
            onChange={searchContacts}
          ></TextField>
          <Button onClick={() => setOpenNewReferee(true)}>Add New</Button>
          <Dialog open={openNewReferee}>
            <DialogTitle>Add New Reviewer</DialogTitle>
            <DialogContent>
              <AddRefereeForm ref={addRefereeForm} />
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenNewReferee(false)}>Cancel</Button>
              <Button onClick={addNewReferee}>Add</Button>
            </DialogActions>
          </Dialog>
        </Box>
        <TableContainer style={{ maxHeight: 500 }}>
          <Table stickyHeader className={classes.table} size="small">
            <TableHead>
              <TableRow>
                {tableHeaders.map((header) => (
                  <TableCell
                    className={classes.tableCell}
                    key={header.label}
                    align="left"
                    style={{ width: header.size }}
                  >
                    {header.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {reviewers.map((reviewer, index) => (
                <ReviewerRow
                  key={index}
                  reviewer={reviewer}
                  addReviewer={addReviewer}
                />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Button
          disableElevation
          variant="contained"
          className={classes.cancelButton}
          onClick={() => openCloseSuggestedReviewers()}
        >
          Close
        </Button>
      </Paper>
    </Paper>
  );
}
